<template>
  <div>
    <v-alert
      v-if="!isUpdated"
      prominent
      border="left"
      color="#662d91"
      transition="scale-transition"
      max-width="600"
    >
      <v-row align="center">
        <v-col class="grow py-0 white--text"
          >Click <span class="font-weight-black white--text">refresh</span> to
          get the latest updates from Spacepack.
        </v-col>
        <v-col class="shrink py-0">
          <v-btn depressed color="white" @click="refresh">
            <p>Refresh</p>
            <v-icon class="ml-2" color="purple darken-2">
              mdi-rocket-launch
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isUpdated: true
    }
  },
  methods: {
    refresh() {
      this.isUpdated = true
      window.location.reload()
    }
  },
  sockets: {
    updateUI() {
      this.isUpdated = false
    }
  }
}
</script>
